import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-intravenous-therapy",
  templateUrl: "./med-icon-intravenous-therapy.component.html",
})
export class MedIconIntravenousTherapyComponent extends SvgMixinComponent {}
